import React$1 from 'react';
import Teaser$1 from '../Teaser/Teaser.js';

const CategoryTeaser = props => {
  return /*#__PURE__*/React$1.createElement(Teaser$1, props);
};

export default CategoryTeaser;
